import React from 'react';
import PropTypes from 'prop-types';
import { Button, Title } from '@nerdwallet/currency';

import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

const PressBanner = ({ header, url, cta }) => (
  <div
    className={classNames([
      'press-banner__container',
      classes('width-100'),
      classes('background-blue-lightest'),
      classes('text-align-center'),
      classes('padding-vertical-5'),
      classes('padding-horizontal-3'),
    ])}
  >
    <Title
      size="large"
      className={classNames([
        'press-banner__heading',
        classes('margin-bottom-4'),
      ])}
    >
      {header}
    </Title>
    <Button className={classNames(['press-banner__btn'])} primary href={url}>
      {cta}
    </Button>
  </div>
);

PressBanner.displayName = 'PressBanner';

PressBanner.propTypes = {
  header: PropTypes.string,
  url: PropTypes.string,
  cta: PropTypes.string,
};

export default PressBanner;
